import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import configBase from 'configBase';
import {verificaCache} from 'verificaCache';

import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import Button from '@material-ui/core/Button';



class VisualizarDocs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showImage: true,
      showPDF: false,

      rotateDeg: 0,
      windowZoom: false,
      scaleZoom: 1,
      mouseMoveEffect: false,

      urlDoc: '',
    };

    this.styles = {
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        top: 20,
        right: 10
      }
    };

    this.eventScreenX = 0;
    this.eventScreenY = 0;
    this.translateX = 0;
    this.translateY = 0;

  }

  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false) {
        let doc = this.props.history.location.search.replace('?doc=', '');

        if (doc && doc.length > 0) {
          let state = this.state;
          let ext = doc.split('.').pop().toLowerCase();
          state.urlDoc = doc;

          // Verifica se é PDF
          if (ext === 'pdf') {
            state.showPDF = true;
            state.showImage = false;
          }

          this.setState(state);
        }
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));    
  }

  redo() {
    let state = this.state;
    let heightImage = document.getElementById('image_doc_spin').offsetHeight;

    if (state.rotateDeg >= 360)
      state.rotateDeg = 90;
    else
      state.rotateDeg = state.rotateDeg + 90;

    if (state.rotateDeg === 90 || state.rotateDeg === 270 ||
        state.rotateDeg === -90 || state.rotateDeg === -270) {
      document.getElementById('image_doc_spin').style.top  = parseFloat(heightImage/2)+'px';
      document.getElementById('image_doc_spin').style.left  = '-20%';
      document.getElementById('root').style.marginBottom  = '20px';
    }
    else {
      document.getElementById('image_doc_spin').style.top  = '0px';
      document.getElementById('image_doc_spin').style.left  = '0%';
    }

    this.setState(state);
    document.getElementById('image_doc_spin_div').style.height = '';
  }

  undo() {
    let state = this.state;
    let heightImage = document.getElementById('image_doc_spin').offsetHeight;

    if (state.rotateDeg <= -360)
      state.rotateDeg = -90;
    else
      state.rotateDeg = state.rotateDeg - 90;

    if (state.rotateDeg === -90 || state.rotateDeg === -270 ||
        state.rotateDeg === 90 || state.rotateDeg === 270) {
      document.getElementById('image_doc_spin').style.top  = parseFloat(heightImage/2)+'px';
      document.getElementById('image_doc_spin').style.left  = '-20%';
    }
    else {
      document.getElementById('image_doc_spin').style.top  = '0px';
      document.getElementById('image_doc_spin').style.left  = '0%';
    }

    this.setState(state);
    document.getElementById('image_doc_spin_div').style.height = '';
  }

  windowZoom() {
    let state = this.state;

    if (state.windowZoom)
      document.getElementById('content_zoom').style.display = 'none';
    else
      document.getElementById('content_zoom').style.display = 'block';

    state.windowZoom = !state.windowZoom;
    this.setState(state);
  }

  scaleZoom(event) {
    let state = this.state;

    // Pega a posição atual do mouse
    this.eventScreenX = event.clientX;
    this.eventScreenY = event.clientY;

    // Aumenta a escala
    if (state.scaleZoom === 1) {
      document.getElementById('image_zoom').style.transform = 'scale(2) rotate('+this.state.rotateDeg+'deg)';
      document.getElementById('image_zoom').style.cursor = 'zoom-out';
      document.getElementById('content_zoom').style.cursor = 'zoom-out';
      document.getElementById('image_zoom_close').style.display = 'none';
      state.scaleZoom = 2;
      state.mouseMoveEffect = true;
    }
    // Diminui a escala
    else {
      document.getElementById('image_zoom').style.transform = 'scale(1) rotate('+this.state.rotateDeg+'deg)';
      document.getElementById('image_zoom').style.cursor = 'zoom-in';
      document.getElementById('content_zoom').style.cursor = 'zoom-in';
      document.getElementById('image_zoom_close').style.display = 'block';
      state.scaleZoom = 1;
      state.mouseMoveEffect = false;
    }

    this.setState(state);
  }

  mouseMoveZoom(event) {
    if (this.state.mouseMoveEffect) {
      // Para o eixo Y
      if (event.clientY > this.eventScreenY)
        this.translateY -= 12;
      else if (event.clientY < this.eventScreenY)
        this.translateY += 12;

      // Para o eixo X
      if (event.clientX > this.eventScreenX)
        this.translateX -= 15;
      else if (event.clientX < this.eventScreenX)
        this.translateX += 15;

      this.eventScreenX = event.clientX;
      this.eventScreenY = event.clientY;

      document.getElementById('image_zoom').style.transform = 'translateY('+this.translateY+'px) translateX('+this.translateX+'px) scale(2) rotate('+this.state.rotateDeg+'deg)';
    }
  }


  render() {

    return (
      <div style={{height: '100%'}}>
        {
          this.state.showImage === true ? (
        <div style={{marginTop: 10, marginBottom: 10, height: 45, marginLeft: 13}}>
          <div style={{position: 'fixed', zIndex: 1}}>
            <Button
              variant="contained"
              color="default"
              onClick={this.undo.bind(this)}
              size="large"
            >
              <RotateLeftIcon />
            </Button>

            <span>&nbsp;&nbsp;&nbsp;</span>

            <Button
              variant="contained"
              color="default"
              onClick={this.redo.bind(this)}
              size="large"
              >
                <RotateRightIcon />
              </Button>
          </div>
        </div>
          ) : ('')
        }

        <div
          id="image_doc_spin_div"
          style={{textAlign: 'center', height: '100%', position: 'relative'}}
        >
          {
            this.state.showImage === true ? (
              this.state.urlDoc.length > 0 && (
          <div>
            <img
              id="image_doc_spin"
              alt=""
              width="600"
              style={{cursor: 'pointer', padding: '0 10px', bottom: 0, transform: 'rotate('+this.state.rotateDeg+'deg)', position: 'relative'}}
              src={configBase.api + 'attachments/docs/download/' + this.state.urlDoc}
              onClick={this.windowZoom.bind(this)}
            />
            <div
              id="content_zoom"
              onMouseMove={this.mouseMoveZoom.bind(this)}
              onClick={this.scaleZoom.bind(this)}
              style={{cursor: 'zoom-in'}}
            >
              <img
                id="image_zoom_close"
                alt=""
                style={this.styles.closeBtn}
                src={`${process.env.PUBLIC_URL}/images/icon_close.png`}
                onClick={this.windowZoom.bind(this)}
              />

              <img
                id="image_zoom"
                alt=""
                width="100%"
                style={{cursor: 'zoom-in', padding: '0 10px', bottom: 0, transform: 'rotate('+this.state.rotateDeg+'deg)', position: 'relative'}}
                src={configBase.api + 'attachments/docs/download/' + this.state.urlDoc}
              />
            </div>
          </div>
              )
            ) : ('')
          }

          {
            this.state.showPDF === true ? (
              this.state.urlDoc.length > 0 && (
          <iframe
            src={configBase.api + 'attachments/docs/download/' + this.state.urlDoc}
            width="95%" height="600px"
            title="anexo"
          />
              )
            ) : ('')
          }
        </div>

        <style>{`
          #container_page {
            padding: 0;
            margin: 0;
            max-width: 100%;
          }
          #content_zoom {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            background-color: #ddd;
            z-index: 1;
            display: none;
          }
          #content_zoom img {
            top: 15%;
            position: relative;
          }
        `}
        </style>

      </div>
    );

  }

}

VisualizarDocs.propTypes = {
  history: PropTypes.object
};

export default withRouter(VisualizarDocs);